export default __webpack_public_path__ + "static/media/robot.d1c114bb.png";